module.exports = __webpack_public_path__ + "static/media/CLDA 2021 FMF Promo Video Script_1617621954211.00c3b455.docx";